import {
  StickyAppBar,
  GenButton,
  GenSnackBar,
} from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  approveOrder,
  closeDeclineConfirm,
  declineOrder,
  openDeclineConfirm,
} from '../../../redux/actions/orderDetailsActions';
import {
  clearDeclinedConfirmation,
  closeApproveDialog,
} from '../../../redux/actions/orders/unapprovedActions';
import {
  selectDeclineConfirmOpen,
  selectIsProcessingAction,
  selectApproveDialogOpened,
  selectShowDeclinedErrorSnackBar,
  selectShowDeclinedSuccesSnackBar,
} from '../../../redux/selectors/ordersDetailsSelectors';
import { isApprover } from '../../../redux/selectors/userDataSelectors';
import OrderConfirmDialog from '../../orders/components/OrderConfirmDialog';
import OrderDeclineDialog from '../../orders/components/OrderDeclineDialog';

export default function ApproveFooter({ data }) {
  const { t } = useTranslation('orders');
  const dispatch = useDispatch();
  const history = useHistory();
  const isProcessingAction = useSelector(selectIsProcessingAction);
  const declineOpen = useSelector(selectDeclineConfirmOpen);
  const approver = useSelector(isApprover);
  const approveDialogOpened = useSelector(selectApproveDialogOpened);
  const showDeclinedSuccesSnackBar = useSelector(
    selectShowDeclinedSuccesSnackBar
  );
  const showDeclinedErrorSnackBar = useSelector(
    selectShowDeclinedErrorSnackBar
  );

  const approve = () => {
    dispatch(approveOrder(data));
  };

  const decline = observation => {
    dispatch(
      declineOrder({
        order: data,
        observation,
      })
    );
  };

  const navigateToWorkQueue = () => {
    history.push('/workQueue');
  };

  const hideDeclinedConfirmation = () => {
    dispatch(clearDeclinedConfirmation());
  };

  return (
    <>
      <OrderDeclineDialog
        onClose={() => dispatch(closeDeclineConfirm())}
        open={declineOpen}
        order={data}
        processingAction={isProcessingAction}
        onConfirm={observation => decline(observation)}
        onSuccess={showDeclinedSuccesSnackBar}
      />
      <GenSnackBar
        title={t('declinedConfirmation')}
        open={showDeclinedSuccesSnackBar}
        onClose={() => hideDeclinedConfirmation()}
      />
      <GenSnackBar
        title={t('declinedError')}
        open={showDeclinedErrorSnackBar}
        type="error"
        onClose={() => hideDeclinedConfirmation()}
      />
      <OrderConfirmDialog
        onClose={() => dispatch(closeApproveDialog())}
        open={approveDialogOpened}
        order={data}
        processingAction={isProcessingAction}
        onConfirm={() => navigateToWorkQueue()}
      />
      {data && approver && data.requiresApproval && (
        <StickyAppBar
          display={data.requiresApproval}
          title={t('approveTitle')}
          subtitle={t('approveSubtitle')}
          buttons={[
            <GenButton
              text={t('actionButtons.decline')}
              color="error"
              variant="outlined"
              onClick={() => dispatch(openDeclineConfirm())}
              disabled={isProcessingAction}
            />,
            <GenButton
              text={t('actionButtons.approve')}
              color="success"
              variant="outlined"
              onClick={approve}
              disabled={isProcessingAction}
            />,
          ]}
        />
      )}
    </>
  );
}
